import React from "react";
import ReactDOM from "react-dom";

interface DropdownPortalProps {
  isOpen: boolean;
  onClose: () => void;
  position: { x: number; y: number };
  children: React.ReactNode;
}

const DropdownPortal: React.FC<DropdownPortalProps> = ({ isOpen, onClose, position, children }) => {
  if (!isOpen) return null;
  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 2000,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "absolute",
          top: position.y,
          left: position.x,
          backgroundColor: "#fff",
          borderRadius: "4px",
          padding: "1rem",
          minWidth: "200px",
        }}
      >
        {children}
      </div>
    </div>,
    document.body
  );
};

export default DropdownPortal;
